module.exports = __webpack_public_path__ + "img/map-icon.1bae76e9.png";